import { useEffect, useState } from 'react';
import styles from './RITRequest.module.css';
import { useRITRequestEndTime } from '@/src/hooks/data/useGameTable';
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import gameAssets from '@themed-assets';

const RITRequest = ({ tempTableId, tableId, playerName }) => {
    const RITRequestEndTime = useRITRequestEndTime(tempTableId);
    const [duration, setDuration] = useState(0);
    const { sendRITAck } = useGameSocket(tempTableId);

    useEffect(() => {
        if (RITRequestEndTime) {
            const currentTime = Date.now();
            const timeLeft = RITRequestEndTime - currentTime;
            setDuration(timeLeft > 0 ? timeLeft / 1000 : 0);
        }
    }, [RITRequestEndTime]);

    const onReject = () => {
        sendRITAck(false);
    }

    const onAccept = () => {
        sendRITAck(true);
    }

    return (
        <div className={styles.popup}>
            <div
                className={styles.timerBar}
                style={{
                    animationDuration: `${duration}s`
                }}
            >
                <div className={styles.timerDot}></div>
            </div>
            <div className={styles.contentRow}>
                <div className={styles.leftCol}>
                    <img src={gameAssets.rit} alt="RIT Icon" className={styles.ritIcon} />
                    <span className={styles.text}>Do you want to Run it twice?</span>
                </div>
                <div className={styles.buttonRow}>
                    <div className={`${styles.button} ${styles.rejectButton}`} onClick={onReject}>No</div>
                    <div className={`${styles.button} ${styles.ritButton}`} onClick={onAccept}>RUN IT TWICE</div>
                </div>
            </div>
        </div>
    );
};

export default RITRequest;
